<script>

	import { createEventDispatcher, tick } from 'svelte';

	import Avatar from "../../../../ui/Avatar.svelte";
	import Menu from "../../../../ui/Menu.svelte";
	import Button from "../../../../ui/Button.svelte";
	import Dialog from "../../../../ui/Dialog.svelte";

	import { event, attendee, attendeeLikes, shadowbans, session, spotlight } from '../../../../lib/stores.js';
	import { showDate } from '../../../../lib/dt.js';
	import { postServerData } from '../../../../lib/prelude.js';
	import { autoblur } from '../../../../lib/autoblur.js';
	// import { logInteraction } from '../../../../lib/usage.js';

	const dispatch = createEventDispatcher();

	export let q;
	// export let selectedMsg;
	export let questions;
	export let mod;
	export let showUtils;
	export let participants = {};

	export const closeMenu = () => { avatar.closeMenu() };

	let avatar;
	let avatarMenu = false;

	let deleteQuestionDialog = null;

	let allowMarkAsAnswered = false; // we may want to remove this feature altogether

	async function toggleLike() {
		// Update immediately; Sync revision will update again...
		if (q.liked) {
			q.likes--;
			q.liked = false;
		} else {
			q.likes++;
			q.liked = true;
			// logInteraction('now/qa/likes');
		}
		// selectedMsg = null;
		const d = new Date;
		q.revision = q.index + '/' + d.getTime();
		questions = questions;
		// console.log(reply);
		await postServerData('onstage/likes', {
			channelRef: $session.syncChannel,
			messageIndex: q.index
		});
	}

	function actionDelete() {
		// $modal = {
		// 	message: 'Please confirm you wish to delete this message.',
		// 	details: [],
		// 	opts: [
		// 		{
		// 			name: "Delete",
		// 			display: {
		// 				mini: true,
		// 				red: true
		// 			},
		// 			f: () => {
		// 				doDelete();
		// 			}
		// 		},
		// 		{
		// 			name: "Cancel",
		// 			display: {
		// 				mini: true,
		// 				ghost: true
		// 			},
		// 			f: () => {}
		// 		},
		// 	]
		// };
		deleteQuestionDialog = {
			text: "Are you sure you want to delete this message?",
			actions: [
				{
					label: "Confirm",
					dispatch: "confirm"
				},
				{
					label: "Cancel",
					ghost: true,
					dispatch: "escape"
				}
			]
		};
	}

	async function doDelete() {
		// selectedMsg = null;
		deleteQuestionDialog = null;
		await postServerData('onstage/qa/delete', {
			sessionRef: $session.ref,
			index: q.index
		});
	}

	// async function actionAnswered() {
	// 	await postServerData('onstage/qa/answered', {
	// 		sessionRef: $session.ref,
	// 		index: q.index
	// 	});
	// }

	function actionApprove() {
		// selectedMsg = null;
		postServerData('onstage/qa/approved', {
			sessionRef: $session.ref,
			index: q.index
		});
	}

	function actionReject() {
		postServerData('onstage/qa/rejected', {
			sessionRef: $session.ref,
			index: q.index
		});
	}

	function actionClose() {
		postServerData('onstage/qa/closed', {
			sessionRef: $session.ref,
			index: q.index
		});
	}

	function actionRestore() {
		if (q.rejected) {
			postServerData('onstage/qa/rejected', {
				sessionRef: $session.ref,
				index: q.index,
				restore: 1
			});
		} else {
			postServerData('onstage/qa/closed', {
				sessionRef: $session.ref,
				index: q.index,
				restore: 1
			});
		}
	}

	// function handleClick() {
	// 	selectedMsg = (selectedMsg == q.index) ? null : q.index;
	// }

	function openMenu() {
		avatarMenu = true;
		dispatch('openMenu', q.index);
	}

	function toggleHighlight() {
		if (studioHighlight && (studioHighlight.t == 'qa') && (studioHighlight.r == q.index)) {
			dispatch('highlight', null);
		} else {
			dispatch('highlight', { t: 'qa', r: q.index });
		}
	}

	function toggleSpotlight(m) {
		setTimeout(() => {
			if ($spotlight && ($spotlight.type == 'qa') && ($spotlight.index == m.index)) {
				$spotlight = null;
			} else {
				$spotlight = {
					type: 'qa',
					message: m.message,
					sender: m.sender,
					index: m.index,
					anon: m.anon,
					session: $session.ref
				};
			}
		}, 100);
	}

</script>

<style>
	div {
		position: relative;
	}
	.msg {
		position: relative;
/*		background: var(--bgColor, #fff);*/
		color: var(--textColor);
		border-radius: 4px;
		padding: 0.5rem 0.5rem 0.5rem 3.4rem;
		word-wrap: break-word;
		background: var(--blend-05);
	}
	.msg :global(.avatar) {
		position: absolute;
		top: 0.6rem;
		left: 0.7rem;
		width: 2rem;
		height: 2rem;
	}
	.msg :global(p) {
		font-size: 0.9rem;
		line-height: 1.4;
	}

	.person {
		margin-bottom: 0.2rem;
	}
	.person strong {
		font-weight: 700;
	}
	.person span {
		display: inline-block;
		margin-left: 0.3rem;
		opacity: 0.6;
		font-size: 0.9rem;
	}

	.msg.muted {
		display: none !important;
	}

	/*.msg span.answered {
		display: inline-block;
		font-size: 0.6rem;
		color: var(--blend-80);
		font-weight: 600;
		box-shadow: 0 0 0 1px var(--blend-80);
		padding: 0 3px;
    	letter-spacing: 0.05em;
    	border-radius: 2px;
		opacity: 1;
		text-transform: uppercase;
		position: relative;
		top: -0.075rem;
	}*/

	.msg span.pending {
		display: inline-block;
		font-size: 0.6rem;
		color: var(--errorColor);
		font-weight: 600;
		box-shadow: 0 0 0 1px var(--errorColor);
		padding: 0 3px;
    	letter-spacing: 0.05em;
    	border-radius: 2px;
		opacity: 1;
		text-transform: uppercase;
		position: relative;
		top: -0.075rem;
	}

	.msg span.approved {
		display: inline-block;
		font-size: 0.6rem;
		color: var(--bgColor);
		background: var(--accentColor);
		font-weight: 600;
		box-shadow: 0 0 0 1px var(--accentColor);
		padding: 0 3px;
    	letter-spacing: 0.05em;
    	border-radius: 2px;
		opacity: 1;
		text-transform: uppercase;
		position: relative;
		top: -0.075rem;
	}

	.likes {
		display: flex;
		margin-top: 0.6rem;
		line-height: 1;
		margin-bottom: -0.1em;
		justify-content: space-between;
		padding: 0.5rem 0.5rem 0.25rem 0;
	}
	.likes span {
		vertical-align: middle;
		/*color: var(--blend-60);*/
		font-size: 0.8rem;
		font-weight: 600;
	}
	.likes svg {
		display: inline-block;
		/*width: 1em;
		height: 1em;*/
		width: 1.8em;
		height: 1.8em;
		vertical-align: middle;
		/*margin-left: 0.1em;*/
	}

	.likes button {
		display: flex;
		cursor: pointer;
		align-items: center;
		justify-content: flex-start;
		gap: 0.2em;
		padding: 0;
		border: 0;
		background: transparent;
		color: var(--textColor);
		font-size: 0.9rem;
	}

	.likes > span {
		display: flex;
		gap: 1.4rem;
	}

	.likes span.buttonLabel {
		font-weight: 400;
	}

	.likes button:hover {
		color: var(--accentColor);
	}

	.likes button.lit {
		color: var(--accentColor);
	}

	.likes button.lit.spotlight {
		color: var(--errorColor);
	}

	.msg :global(button.close) {
		padding: 0.8rem 1.2rem;
		width: 0.6rem;
		height: 0.6rem;
		opacity: 0.8;
	}

	.msg:hover :global(button.close) {
		opacity: 1;
	}

	.msg :global(button.close:hover) {
		color: var(--errorColor);
	}

</style>

<div
	class="msg"
	class:muted={$shadowbans.includes(q.sender) && (q.sender != $attendee.ref)}
	class:openMenu={avatarMenu}
>

	{#if participants[q.sender] && participants[q.sender].type && (participants[q.sender].type == 'login') && (!participants[q.sender].f || !participants[q.sender].l)}
		<Avatar
			identity={participants[q.sender]}
			anon={true}
			bind:this={avatar}
		>
			{#if $event.theme.favicon && $event.theme.favicon.filename}
				<img
					class="icon"
					src="https://cdn.attendzen.io/{$event.accountRef}/{$event.theme.favicon.filename}"
					alt={$event.name}
					crossorigin="anonymous"
				/>
			{/if}
		</Avatar>
	{:else}
		<Avatar
			identity={participants[q.sender]}
			hasMenu={participants[q.sender] && participants[q.sender].type && (participants[q.sender].type != 'login')}
			anon={q.anon}
			on:open={openMenu}
			on:close={closeMenu}
			bind:this={avatar}
		/>
	{/if}
	<p class="person">
		{#if q.anon}
			<strong>Anonymous</strong>
		{:else}
			{#if participants[q.sender]}
				{#if (participants[q.sender].type == 'login') && (!participants[q.sender].f || !participants[q.sender].l)}
					<strong>{$event.name}</strong>
				{:else}
					<strong>{participants[q.sender].f} {participants[q.sender].l}</strong>
				{/if}
			{/if}
		{/if}
		{#if (showUtils && !q.approved && !q.rejected)}
			<span class="pending">New</span>
		{/if}
		{#if (showUtils && q.approved)}
			<span class="approved">Approved</span>
		{/if}
		<span>{showDate(q.sent, 'HH:mm')}</span>
	</p>
	<div class="message">
		{@html q.message}
	</div>
	{#key q.revision}
		<p class="likes">
			<span>
				<button type="button" on:click|stopPropagation={toggleLike(q)} use:autoblur>
					<svg viewBox="0 0 20 20">
						{#if q.liked}
							<path d="M8.26 14.73c.56.48 1.28.48 1.31.48h4.55c.7-.04 1.24-.62 1.24-1.31 0-.11-.01-.21-.04-.31.48-.2.8-.67.8-1.21 0-.18-.04-.35-.1-.51.39-.23.63-.66.63-1.12 0-.36-.15-.7-.4-.94.18-.23.28-.51.28-.8 0-.34-.13-.67-.38-.92-.26-.26-.61-.41-.98-.41h-2.84l.18-1.18c.02-.15.03-.3.03-.45 0-1.17-.79-2.53-1.81-2.53-.29 0-.58.1-.81.29l-.09.07.15 1.95c.01.08 0 .17-.02.24l-.09.23-1.56 2.89-.05.05v5.49zM6.93 15.5c.3 0 .55-.24.55-.55v-5.7c0-.3-.24-.55-.55-.55h-3.03c-.3 0-.55.24-.55.55v5.7c0 .3.24.55.55.55h3.03z"/>
						{:else}
							<path d="M10.1 15.15c-.09 0-.87-.02-1.5-.55l-.18-.15v-4.97c0-.25.07-.51.19-.73l1.36-2.52-.14-2.02.29-.24c.29-.25.67-.38 1.05-.38 1.22 0 2.13 1.47 2.13 2.79 0 .16-.01.33-.04.48l-.08.49h1.98c.46 0 .91.19 1.24.52.32.32.49.74.49 1.18 0 .24-.05.47-.15.68.17.27.26.58.26.89 0 .46-.18.89-.5 1.2l.02.28c0 .55-.26 1.05-.69 1.36v.01c0 .9-.7 1.63-1.59 1.68h-4.14zm-.68-1.19c.33.19.68.19.68.19h4.1c.35-.02.63-.32.63-.69l-.02-.16-.1-.41.39-.17c.25-.11.42-.36.42-.63 0-.09-.02-.18-.05-.27l-.17-.4.37-.22c.21-.12.33-.34.33-.59 0-.18-.08-.36-.21-.49l-.32-.31.28-.35c.09-.12.14-.26.15-.42 0-.17-.07-.34-.2-.47-.14-.14-.33-.22-.53-.22h-3.14l.25-1.64.03-.33c0-.87-.58-1.79-1.13-1.79-.11 0-.21.03-.31.08l.11 1.48c.01.13 0 .25-.03.38-.03.12-.08.24-.14.35l-1.32 2.35c-.04.08-.07.16-.07.25v4.48zM6.44 15.42h-2.41c-.55 0-.99-.44-.99-.99v-5.15c0-.55.44-.99.99-.99h2.41c.55 0 .99.44.99.99v5.14c0 .55-.44 1-.99 1zm-.51-6.14h-1.4c-.28 0-.5.22-.5.5l.01 4.14c0 .28.23.5.5.5h1.4c.28 0 .5-.22.5-.5v-4.14c-.01-.27-.23-.5-.51-.5z"/>
						{/if}
					</svg>
					<span>{q.likes}</span>
				</button>
				{#if q.rejected || q.closed}
					{#if mod}
						<button type="button" on:click|stopPropagation={actionRestore} use:autoblur>
							<svg viewBox="0 0 80 80"><title>Restore</title><path d="m21.1 40c0-11.53 9.38-20.91 20.91-20.91s20.91 9.38 20.91 20.91-9.38 20.91-20.91 20.91v4c13.74 0 24.91-11.18 24.91-24.91s-11.17-24.91-24.91-24.91-24.91 11.17-24.91 24.91h-6.02l8.34 14.32 8.35-14.32z"/></svg>
							<span class="buttonLabel">Restore</span>
						</button>
						<button type="button" on:click|stopPropagation={actionDelete} use:autoblur>
							<svg viewBox="0 0 20 20"><title>Delete</title><path d="M12 14.5c-.28 0-.5-.22-.5-.5v-5.01c0-.28.22-.5.5-.5s.5.22.5.5v5.01c0 .28-.22.5-.5.5zM10 14.5c-.28 0-.5-.22-.5-.5v-5c0-.28.22-.5.5-.5s.5.22.5.5v5.01c0 .27-.22.49-.5.49zM8 14.5c-.28 0-.5-.22-.5-.5v-5c0-.28.22-.5.5-.5s.5.22.5.5v5.01c0 .27-.22.49-.5.49zM15.5 5.5c0-.55-.45-1-1-1h-2.49c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1h-2.51c-.55 0-1 .45-1 1v2h1v8c0 .55.45 1 1 1h7c.55 0 1-.45 1-1v-8h1v-2zm-2 9.5c0 .28-.22.5-.5.5h-6c-.28 0-.5-.22-.5-.5v-7.5h7v7.5zm1-8.5h-9v-.49c0-.28.22-.5.5-.5h8c.28 0 .5.22.5.5v.49z"/></svg>
							<span class="buttonLabel">Delete</span>
						</button>
					{/if}
				{:else}
					{#if showUtils && !q.approved}
						<button type="button" on:click|stopPropagation={actionApprove} use:autoblur>
							<svg viewBox="0 0 20 20"><path d="m10 3c-3.8 0-7 3.2-7 7s3.2 7 7 7 7-3.2 7-7-3.2-7-7-7zm-1.2 10.7-3.1-3.1 1.2-1.2 1.9 1.9 4.3-4.3 1.2 1.2z"/></svg>
							<span class="buttonLabel">Approve</span>
						</button>
						<button type="button" on:click|stopPropagation={actionReject} use:autoblur>
							<svg viewBox="0 0 20 20"><path d="m10 3c-3.8 0-7 3.2-7 7s3.2 7 7 7 7-3.2 7-7-3.2-7-7-7zm3.6 9.4-1.2 1.2-2.4-2.4-2.4 2.4-1.2-1.2 2.4-2.4-2.4-2.4 1.2-1.2 2.4 2.4 2.4-2.4 1.2 1.2-2.4 2.4z"/></svg>
							<span class="buttonLabel">Reject</span>
						</button>
					{/if}
					{#if ((mod && !showUtils) || (!mod && ($attendee.type != 'login') && (q.sender == $attendee.ref)))}
						<button type="button" on:click|stopPropagation={actionDelete} use:autoblur>
							<svg viewBox="0 0 20 20"><title>Delete</title><path d="M12 14.5c-.28 0-.5-.22-.5-.5v-5.01c0-.28.22-.5.5-.5s.5.22.5.5v5.01c0 .28-.22.5-.5.5zM10 14.5c-.28 0-.5-.22-.5-.5v-5c0-.28.22-.5.5-.5s.5.22.5.5v5.01c0 .27-.22.49-.5.49zM8 14.5c-.28 0-.5-.22-.5-.5v-5c0-.28.22-.5.5-.5s.5.22.5.5v5.01c0 .27-.22.49-.5.49zM15.5 5.5c0-.55-.45-1-1-1h-2.49c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1h-2.51c-.55 0-1 .45-1 1v2h1v8c0 .55.45 1 1 1h7c.55 0 1-.45 1-1v-8h1v-2zm-2 9.5c0 .28-.22.5-.5.5h-6c-.28 0-.5-.22-.5-.5v-7.5h7v7.5zm1-8.5h-9v-.49c0-.28.22-.5.5-.5h8c.28 0 .5.22.5.5v.49z"/></svg>
							<span class="buttonLabel">Delete</span>
						</button>
					{/if}
				{/if}
			</span>
			{#if q.approved && !q.rejected && !q.closed}
				<span>
					<button type="button" class="spotlight" on:click|stopPropagation={toggleSpotlight(q)} use:autoblur class:lit={$spotlight && ($spotlight.type == 'qa') && ($spotlight.index == q.index)}>
						{#if $spotlight && ($spotlight.type == 'qa') && ($spotlight.index == q.index)}
							<span class="buttonLabel">Take off screen</span>
						{:else}
							<span class="buttonLabel">Show on screen</span>
						{/if}
						<svg viewBox="0 0 80 80">
							{#if $spotlight && ($spotlight.type == 'qa') && ($spotlight.index == q.index)}
								<path d="m69.6 22.4c0-1.3-1.1-2.6-2.6-2.8-8.1-1.1-27-1.1-27-1.1s-18.9 0-27 1.1c-1.5.2-2.6 1.5-2.6 2.8-.4 8.6-.4 17.6-.4 17.6s0 9 .4 17.6c0 1.3 1.1 2.6 2.6 2.8 8.1 1.1 27 1.1 27 1.1s18.9 0 27-1.1c1.3-.2 2.4-1.3 2.6-2.8.4-8.6.4-17.6.4-17.6s0-9-.4-17.6zm-19.2 20.1h-20.9v-4.9h20.9z"/>
							{:else}
								<path d="m42.4 29.5v8.1h8v4.9h-8v8h-4.8v-8h-8v-4.9h8v-8.1z"/><path d="m40 22.6c.2 0 15.5 0 24.4.9.9 0 1.5.7 1.5 1.5.2 7.6.2 15 .2 15s0 7.4-.2 15c0 .9-.7 1.5-1.5 1.5-8.9.9-24.2.9-24.4.9s-15.5 0-24.4-.9c-.9 0-1.5-.7-1.5-1.5-.2-7.6-.2-14.8-.2-15 0 0 0-7.4.2-15 0-.9.7-1.5 1.5-1.5 8.9-.9 24.2-.9 24.4-.9m0-4s-18.9 0-27 1.1c-1.5.2-2.6 1.5-2.6 2.8-.4 8.5-.4 17.5-.4 17.5s0 9 .4 17.6c0 1.3 1.1 2.6 2.6 2.8 8.1 1.1 27 1.1 27 1.1s18.9 0 27-1.1c1.3-.2 2.4-1.3 2.6-2.8.4-8.6.4-17.6.4-17.6s0-9-.4-17.6c0-1.3-1.1-2.6-2.6-2.8-8.1-1-27-1-27-1z"/>
							{/if}
						</svg>
					</button>
				</span>
			{/if}
		</p>
		{#if showUtils && q.approved && !q.closed}
			<Button on:click={actionClose} close={true}/>
		{/if}
	{/key}
</div>

{#if deleteQuestionDialog}
	<Dialog
		{...deleteQuestionDialog}
		on:escape={() => { deleteQuestionDialog = null}}
		on:confirm={doDelete}
	/>
{/if}
